import { parseJSON } from '../../utils/helperUtil';
import { invokeVzTag } from '../../utils/unifiedVzTag';

const trackClick = (e) => {
  // const event = new CustomEvent('track-event', {
  //   bubbles: true,
  //   composed: true,
  //   detail: {
  //     track: e.currentTarget.getAttribute('data-track'),
  //   },
  // });
  // e.currentTarget.dispatchEvent(event);
  const dataTrackData = parseJSON(e.currentTarget.getAttribute('data-track'));
  if (dataTrackData) {
    invokeVzTag('linkClick', dataTrackData);
  }
};
export const addListener = (allElements) => {
  allElements.forEach((e) => {
    e.addEventListener('click', trackClick);
  });
};
export const removeListener = (allElements) => {
  allElements.forEach((e) => {
    e.removeEventListener('click', trackClick);
  });
};
const trackEventListener = (e) => {
  console.log('data-track-data');
  const dataTrackData = parseJSON(e.detail.track);
  if (window.coreData && dataTrackData) {
    window.coreData.push({
      task: 'emit',
      event: 'linkClick',
      params: { ...dataTrackData },
    });
  }
};
export const addListenTrackEvent = () => {
  document.addEventListener('track-event', trackEventListener);
};

export const removeListenTrackEvent = () => {
  document.removeEventListener('track-event', trackEventListener);
};
